export const STANDUP_REQUEST_DATA = 'STANDUP/REQUEST_DATA';
export const STANDUP_BEGIN_WRITE_DATA = 'STANDUP/BEGIN_WRITE_DATA';
export const STANDUP_COMPLETE_WRITE_DATA = 'STANDUP/COMPLETE_WRITE_DATA';
export const RECEIVE_STANDUPS = 'STANDUP/RECEIVE_STANDUPS';
